import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex';
import { esBloqueoCiclo, dispararBloqueoCiclo } from '@/utils/bloqueoCiclo'

export default {

	data: () => ({
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta:false,
    loader: true,
    cargar: false,
  }),
  
	methods: {
		validarrespuestaAlerta( error ){ 
			return new Promise( (resolve, reject) => {
				if( error.status == 400){
					resolve( error.body.message )
				}else{
					reject( error )
				}
			})
		},


		consultar_niveles_usuario(){
			return new Promise( (resolve) => {
				this.$http.get('niveles.activas').then((response)=>{
					console.log(response.body)
					resolve(response.body)
				}).catch(error =>{
					console.log('error niveles', error)
				})
			})
		},

		validarSuccess( mensaje ){
      this.cargar = false
      this.parametros.mensaje      = mensaje
      this.parametros.dialogError  = true 
      this.parametros.color        = 'success'
      this.respuestaAlerta         = true 
    },

    validarError ( value ) {
      this.cargar = false
      if (esBloqueoCiclo(value)) {
        dispararBloqueoCiclo(value)
        return
      }
      let mensaje = 'Error inesperado'
      
      // Validar que value sea un objeto
      if (!value) {
        mensaje = 'Error desconocido'
      } else if (typeof value === 'string') {
        // Si es un string, usarlo directamente
        mensaje = value
      } else if (value.status) {
        // Manejo basado en código de estado HTTP
        if (value.status == 400) {
          mensaje = value.body?.message || 'Solicitud inválida'
        } else if (value.status == 401) {
          mensaje = value.body?.message || 'No autorizado. Por favor, inicia sesión de nuevo'
        } else if (value.status == 403) {
          mensaje = value.body?.message || 'No tienes permisos para realizar esta acción'
        } else if (value.status == 404) {
          mensaje = 'Ruta no encontrada, levantar un ticket, por favor'
        } else if (value.status == 409) {
          mensaje = value.body?.message || 'Conflicto en la solicitud'
        } else if (value.status == 422) {
          mensaje = value.body?.message || 'Datos inválidos'
        } else if (value.status == 500) {
          mensaje = value.body?.message || 'Error en el servidor'
        } else if (value.status == 503) {
          mensaje = 'El servidor no está disponible. Intenta más tarde'
        } else if (value.status == 0) {
          mensaje = 'El servidor no se encuentra activo, contacta a sistemas'
        } else {
          mensaje = value.body?.message || `Error: ${value.status}`
        }
      } else if (value.body?.message) {
        // Si tiene body.message, usarlo
        mensaje = value.body.message
      } else if (value.message) {
        // Si tiene message directo
        mensaje = value.message
      } else if (value.statusText) {
        // Si tiene statusText
        mensaje = value.statusText
      }
      
      this.parametros.mensaje      = mensaje
      this.parametros.dialogError  = true 
      this.parametros.color        = '#FF2C2C'
      this.respuestaAlerta         = true 
    },

    validarErrorDirecto ( mensaje ) {
      this.cargar = false
      if (esBloqueoCiclo(mensaje)) {
        dispararBloqueoCiclo(mensaje)
        return
      }
      this.parametros.mensaje      = mensaje
      this.parametros.dialogError  = true 
      this.parametros.color        = '#FF2C2C'
      this.respuestaAlerta = true 
    },

    validarErrores ( value ) {
      return this.validarError(value)
    },
  }
}